import styled, { css } from 'styled-components';

export const LabelWrapper = styled.div`
  color: ${props => (props.isHovered ? 'inherit' : `${props.theme.colors.black}`)};
  font-size: 1em;
  display: inline;
  font-family: ${props => (props.isTitleNarrowMedium ? `${props.theme.fontSets.narrowMedium}` : `${props.theme.fontSets.narrowRegular}`)};
  align-self: ${props => (props.alignSelf ? `${props.alignSelf}` : 'center')};
  line-height: ${props => (props.lineHeight ? `${props.lineHeight}` : 1)};
  ${props => props.display && css`
    display: ${props.display};
  `};
  ${props => props.color && css`
    color: ${props.theme.colors[props.color]};
  `};
  ${props => props.size && css`
  font-size: ${props.size}em;
  `};
  ${props => props.weight && css`
    font-weight: ${props.weight};
  `};
  ${props => props.margin && css`
    margin: ${props.margin};
  `};
  ${props => props.fontStyle && css`
    font-style: ${props.fontStyle};
  `};
  ${props => props.textAlignment && css`
    text-align: ${props.textAlignment}
  `};
  ${props => props.uppercase && css`
    text-transform: uppercase;
  `};
   ::selection{
    background: none;
  }
`;

export const PreLabelContainer = styled.span`
  font-family: ${props => (props.theme.fontSets.narrowMedium)};
`;



// WEBPACK FOOTER //
// ./src/lib/components/shared/Label/styles.js